/**
 * Customer Builds section
 * Pauses the auto-scrolling marquee on hover/focus (when enabled via the
 * section's "Pause on hover" setting) and whenever the visitor has
 * prefers-reduced-motion enabled.
 */
(function () {
    var sections = document.querySelectorAll('[data-customer-builds-scroll]');
    if (!sections.length) return;

    var reduceMotionQuery = window.matchMedia
        ? window.matchMedia('(prefers-reduced-motion: reduce)')
        : null;

    sections.forEach(function (section) {
        var pauseOnHover = section.getAttribute('data-pause-on-hover') === 'true';
        var track = section.querySelector('[data-customer-builds-track]');
        if (!track) return;

        function setPaused(paused) {
            section.setAttribute('data-paused', paused ? 'true' : 'false');
        }

        function applyReducedMotion() {
            if (reduceMotionQuery && reduceMotionQuery.matches) {
                setPaused(true);
            }
        }

        applyReducedMotion();
        if (reduceMotionQuery && reduceMotionQuery.addEventListener) {
            reduceMotionQuery.addEventListener('change', applyReducedMotion);
        }

        if (!pauseOnHover) return;

        ['mouseenter', 'focusin'].forEach(function (evt) {
            section.addEventListener(evt, function () {
                setPaused(true);
            });
        });

        ['mouseleave', 'focusout'].forEach(function (evt) {
            section.addEventListener(evt, function () {
                if (!reduceMotionQuery || !reduceMotionQuery.matches) {
                    setPaused(false);
                }
            });
        });
    });
})();